var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import { Modal, Table, Button, Row, Col, Card } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import api from '@/api'; // 导入 api
const DeclaredDifficultyAcroDuetModal = ({ visible, onOk, onCancel, initialSelectedItem, currentRecord, projectTech, }) => {
    const [acroDuetList, setAcroDuetList] = useState([]);
    const [selectedAcroDuetItem, setSelectedAcroDuetItem] = useState(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    // 模拟数据，待替换为实际 API 调用
    useEffect(() => {
        if (visible) {
            const fetchAcroDuetList = () => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    const res = yield api.CoachCardApi.getAcroComponents({});
                    if (res.data && res.data.code === 200) {
                        const data = res.data.data;
                        setAcroDuetList(data);
                        if (initialSelectedItem) {
                            setSelectedAcroDuetItem(initialSelectedItem);
                            setSelectedRowKeys([initialSelectedItem.code]);
                        }
                        else if (data.length > 0) {
                            // 默认选中第一个
                            setSelectedAcroDuetItem(data[0]);
                            setSelectedRowKeys([data[0].code]);
                        }
                    }
                    else {
                        setAcroDuetList([]);
                        setSelectedAcroDuetItem(null);
                        setSelectedRowKeys([]);
                    }
                }
                catch (error) {
                    setAcroDuetList([]);
                    setSelectedAcroDuetItem(null);
                    setSelectedRowKeys([]);
                }
            });
            fetchAcroDuetList();
        }
        else {
            setAcroDuetList([]);
            setSelectedAcroDuetItem(null);
            setSelectedRowKeys([]);
        }
    }, [visible, initialSelectedItem, currentRecord, projectTech]); // 添加依赖项
    const handleOk = () => {
        onOk(selectedAcroDuetItem);
    };
    const handleCancel = () => {
        onCancel();
    };
    const columns = [
        { title: '代码', dataIndex: 'code', key: 'code', width: 80 },
        { title: '难度值', dataIndex: 'dd', key: 'dd', width: 80 },
        { title: '描述', dataIndex: 'description', key: 'description' },
    ];
    const rowSelection = {
        type: 'radio',
        selectedRowKeys: selectedRowKeys,
        onChange: (keys, selectedRows) => {
            setSelectedRowKeys(keys);
            setSelectedAcroDuetItem(selectedRows.length > 0 ? selectedRows[0] : null);
        },
    };
    return (<Modal title="选择或者构建技巧: Acro Pairs" visible={visible} onOk={handleOk} onCancel={handleCancel} width="80%" bodyStyle={{ minHeight: '40vh', maxHeight: '60vh', overflowY: 'auto' }} footer={[
            <Button key="cancel" onClick={handleCancel} icon={<CloseOutlined />}>
          取消
        </Button>,
            <Button key="ok" type="primary" onClick={handleOk} icon={<CheckOutlined />}>
          确定
        </Button>,
        ]}>
      <Row gutter={16}>
        <Col span={12}>
          <Table rowKey="code" rowSelection={rowSelection} columns={columns} dataSource={acroDuetList} pagination={false} bordered size="small" scroll={{ y: 400 }} onRow={(record) => ({
            onClick: () => {
                setSelectedRowKeys([record.code]);
                setSelectedAcroDuetItem(record);
            },
        })}/>
        </Col>
        <Col span={12} style={{ display: 'flex', flexDirection: 'column', height: 400, alignItems: 'center' }}>
          {(selectedAcroDuetItem === null || selectedAcroDuetItem === void 0 ? void 0 : selectedAcroDuetItem.image) && (<Card cover={<img alt="Acrobatic" src={selectedAcroDuetItem.image} style={{ width: 'auto', maxHeight: '70%', objectFit: 'contain' }}/>} bordered={false} style={{ width: '100%', marginBottom: 16, flex: 1 }}/>)}
          {(selectedAcroDuetItem === null || selectedAcroDuetItem === void 0 ? void 0 : selectedAcroDuetItem.description) && (<Card bordered={false} style={{ width: '100%', marginTop: 'auto', position: 'absolute', bottom: 0 }}>
              <p>{selectedAcroDuetItem.description}</p>
            </Card>)}
        </Col>
      </Row>
    </Modal>);
};
export default DeclaredDifficultyAcroDuetModal;
